import { toast } from 'sonner';

import { useSetClientPortalLogoMutation } from '@/services/api/firmsService';

export const useUpdateClientPortalLogo = ({
  firmId,
}: {
  firmId: string | undefined;
}) => {
  const [setClientPortalLogo, { isLoading }] =
    useSetClientPortalLogoMutation();

  const handleUpdate = async (file: File | null) => {
    if (!firmId) {
      toast.error('Firm not found');
      return;
    }

    try {
      await setClientPortalLogo({
        id: firmId,
        setClientPortalLogoSchema: {
          client_portal_logo: file,
        },
      }).unwrap();

      toast.success(
        file ? 'Client portal logo uploaded' : 'Client portal logo removed',
      );
    } catch {
      toast.error('Failed to update client portal logo');
    }
  };

  return { handleUpdate, isLoading };
};
